import indexer from "../../types/genericTypes";

export const PositionExcComb: indexer = {
	NSE: "equity",
	BSE: "equity",
	NFO: "derivatives",
	CDS: "derivatives",
	MCX: "commodity",
	NCDEX: "commodity"
};
